import {
  LimitsInConstraintGroupFormValue,
  getIsTransactionLimitOnlyEnabled,
} from '@occc/feat-limits';
import { OfferType } from '../../../types';

export const getIsTransactionLimitSupported = (offerType: OfferType | null) => {
  return offerType === OfferType.ProductPurchase;
};

export const getIsTransactionFrequencyLimitSupported = (offerType: OfferType | null): boolean => {
  return offerType === OfferType.ProductPurchase || offerType === OfferType.ExternalFulfillment;
};

/**
 * Default transaction frequency period when the user first enables TFL or adds a row.
 * All offer types that support TFL use DAY; others return undefined.
 */
export const getDefaultTransactionFrequencyPeriod = (
  offerType: OfferType | null,
): 'DAY' | undefined => {
  return getIsTransactionFrequencyLimitSupported(offerType) ? 'DAY' : undefined;
};

/**
 * Determines if the "Set Limits" section should be closed due to Transaction Limit.
 *
 * This function evaluates whether the "Set Limits" section should be closed based on:
 * 1. If award count is enabled ("Set Limits" section is open)
 * 2. If transaction limit is not supported for the given offer type
 * 3. If only transaction limit is enabled in the "Set Limits" section
 *
 * The idea is to hide the "Set Limits" UI section when a user selects an unsupported
 * configuration where only transaction limit is enabled but the current offer
 * type doesn't support this limit type.
 */
export const shouldCloseSetLimitsSectionDueToTransactionLimit = (
  offerType: OfferType | null,
  values: LimitsInConstraintGroupFormValue,
): boolean => {
  const isTransactionLimitSupported = getIsTransactionLimitSupported(offerType);
  const isTransactionLimitOnlyEnabled = getIsTransactionLimitOnlyEnabled(values);

  if (values.isEnabled && !isTransactionLimitSupported && isTransactionLimitOnlyEnabled) {
    return true;
  }

  return false;
};
